import  { Fragment, useEffect, useState } from "react";
import { deleteApi, getApi } from "../../services/api/globalApi";
import { useNavigate } from "react-router";
import { motion } from "framer-motion"
import { FaUsers } from "react-icons/fa";
import { toast } from "react-toastify";

const UserFormulaList = () => {

    const [data, setData] = useState([])

    const getUserLoanFormulaList = async (params) => {
        setData([])
        const path = 'admin/loanCalculations';
        try {
            const data = await getApi({ path, params: { ...params, limit: 8 } });
            console.log(data?.data)
            setData(data?.data.docs)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getUserLoanFormulaList({ page: 1, archive: 0 })
    }, [])


    const navigate = useNavigate()

    const editUserFormula = (item) => {
        navigate(`/user-loans-formula/${item._id}`, { state: item });
    }

    const delteUserFormula = async (item) => {
        try {
            const response = await deleteApi({
                path: `admin/loanCalculations/${item?._id}`,
            });
            toast.success("بانک با موفقیت حذف شد.", {
                position: "top-right",
                closeOnClick: true
            });
            console.log(response);
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.errors.message, {
                position: "top-right",
                closeOnClick: true
            });
        }

    }


    return (
        <Fragment>

            <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                    duration: 0.5,
                    // ease: [0, 0.71, 0.2, 1.01]
                }}
                className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6">

                <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
                    <FaUsers size={26} />
                    لیست نرخ
                </h6>


                {data?.length > 0 ? <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    نام
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    نرخ
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    وضعیت
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    <span className="sr-only">ویرایش</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data ? data?.map((item, index) => {
                                return (
                                    <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {item?.bankName || "-"}
                                        </th>
                                        <td className="px-6 py-4">
                                            {item?.annualBankInterest}
                                        </td>
                                        <td className="px-6 py-4">
                                            {item?.status == 'active' ? <span className="flex items-center gap-x-2">فعال
                                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="text-green-500" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>
                                            </span> : item?.status == 'inactive' ? <span className="flex items-center gap-x-2">
                                                غیر فعال
                                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="text-red-500" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path></svg>
                                            </span> :
                                                <span className="flex items-center gap-x-2">
                                                    در حال بررسی
                                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="text-orange-500" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path></svg>
                                                </span>
                                            }
                                        </td>
                                        <td className="cursor-pointer px-6 py-4 text-right flex gap-2">
                                            <span onClick={() => editUserFormula(item)}>
                                                ویرایش
                                            </span>
                                            <span className="text-red-500" onClick={() => delteUserFormula(item)}>
                                                حذف
                                            </span>
                                        </td>
                                    </tr>
                                )
                            }) : null}

                        </tbody>
                    </table>
                </div>
                    :
                    <p className="w-full py-2 flex justify-center items-center text-gray-800 dark:text-white">شما هنوز هیچ نرخ بانکی ثبت نکرده اید</p>
                }

            </motion.div>
        </Fragment>
    )
}

export default UserFormulaList